import React from "react";
import { Box, Typography } from "@mui/material";

const ZohoTasksPage: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Zoho Tasks
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Coming soon.
      </Typography>
    </Box>
  );
};

export default ZohoTasksPage;
